import { AutogenModelRecurSchedStop, AutogenRowRecurSchedStop } from "./autogen/AutogenModelRecurSchedStop";

export class ModelRecurSchedStop extends AutogenModelRecurSchedStop<RowRecurSchedStop> {
    constructor() {
        super(RowRecurSchedStop);
    }
}

export class RowRecurSchedStop extends AutogenRowRecurSchedStop {
}